import { render } from "./InputHealthChart.vue?vue&type=template&id=19a09f9a"
import script from "./InputHealthChart.vue?vue&type=script&lang=js"
export * from "./InputHealthChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__